<div class="re-container-headline re-mb-30 lg:re-mb-60">
  <h3 data-qa="title">{{ 'payment.title' | translate }}</h3>
</div>

<form (ngSubmit)="save()" (keydown.enter)="$event.preventDefault()" [formGroup]="paymentForm" bdoScrollToInvalidControl [attr.aria-label]="'aria.form.paymentMethod' | translate">
  <div [formGroup]="paymentForm" class="re-bg-white re-w-full re-p-20 re-pb-45 re-mb-30
                                        md:re-w-600 md:re-pt-45 md:re-pb-60 md:re-mx-auto
                                        lg:re-w-900">
    <fieldset name="payment-method" class="re-mb-0">
      <div [attr.data-qa]="'paymentMethod'">
        <div class="bold md:re-text-base md:re-leading-2xl">
          {{ 'payment.subtitle' | translate }}
        </div>
        <div>{{ 'payment.descriptionNewContract' | translate}}</div>

        <div class="re-mb-30 re-mt-30 md:re-mb-20">
          <div class="re-flex re-items-start re-relative re-mb-20">
            <input id="sepa" type="radio" value="sepa" name="paymentMethod" formControlName="paymentMethod" selected>
            <label class="re-ml-15" for="sepa">
              <span class="bold">{{ 'payment.sepa.title' | translate }}</span>
              <span>{{ 'payment.sepa.subtitle' | translate }}</span>
            </label>
          </div>

          <div class="re-flex re-items-start re-relative">
            <input id="bankTransfer" type="radio" value="bankTransfer" name="paymentMethod" formControlName="paymentMethod">
            <label class="re-ml-15 bold" for="bankTransfer">{{ 'banking.manual' | translate }}</label>
          </div>
        </div>

        <div>
          @if (paymentForm.get('paymentMethod')?.value === 'sepa') {
            <div>
              <bdo-sepa-form
                [parentForm]="paymentForm"
                [sepaRequired]="paymentForm.get('paymentMethod')?.value === 'sepa'"
              ></bdo-sepa-form>
            </div>
          }

          @if (paymentForm.get('paymentMethod')?.value === 'bankTransfer') {
            <p class="re-pb-45" [innerHTML]="'payment.bankTransfer.description' | translate"></p>
          }
        </div>
        <div [innerHTML]="'payment.hintMethod' | translate"></div>

        <div class="re-mt-60">
          <div class="bold re-mb-15">{{ 'payment.promoCode.label' | translate }}</div>

          <div class="re-form-item-container re-mb-5">
            <bdo-input
              formControlName="promotionCode"
              [placeholder]="'payment.promoCode.placeholder' | translate"
              [formControl]="$any(paymentForm.get('promotionCode'))"
            ></bdo-input>
          </div>
          @if (!paymentForm.get('promotionCode').pending && paymentForm.get('promotionCode').valid && paymentForm.get('promotionCode').dirty) {
            <div class="re-min-h-27 re-opacity-75 re-text-xs">
              {{ promoSuccessText }}
            </div>
          }
        </div>
      </div>
    </fieldset>
  </div>
  <div class="re-w-full
              md:re-w-600 md:re-mx-auto
              lg:re-w-900">
    <div class="md:re-pl-0 re-pl-15">
      <bdo-validate-submit
        [textButtonLong]="'wizard.button.orderSummary' | translate"
      ></bdo-validate-submit>
      <div class="re-pt-15">{{ 'wizard.button.orderSummaryHint' | translate }}</div>
      <div class="re-pt-60">
        <bdo-text-icon
          [iconPosition]="'left'"
          [text]="'general.action.back' | translate"
          (itemClicked)="location.back()"
          >
        </bdo-text-icon>
      </div>
    </div>
  </div>
</form>
